class Tabs {
  constructor() {
    this.tabs = document.querySelectorAll('.js-tabs li');
    this.contents = document.querySelectorAll('.js-tab-content');
  }
  init() {
    if (this.tabs.length > 0) {
      this.bindEvents();
    }
  }
  bindEvents() {
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', (e) => {
        e.currentTarget.classList.add('is-active');
        const targetId = e.currentTarget.dataset.target;
        this.tabs.forEach((tab) => {
          if (tab !== e.currentTarget) {
            tab.classList.remove('is-active');
          }
        });
        
        this.contents.forEach((content) => {
          if (content.id == targetId) {
            content.classList.add('is-active');
          } else {
            content.classList.remove('is-active');
          }
        });
      });
    });
  }
}

export default new Tabs();
